export default "__VITE_ASSET__BdIE3rBf__"